import { push, goBack } from 'connected-react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

import { importPatient } from '../../../actions/entities/patients/commandActions';
import { checkFeatureAccess } from '../../../utils/helpers';
import globals from '../../../globals/communityGlobals';
import { getSettings } from '../../../actions/entities';
import _ from '../../../utils/lodash';
import { ENABLE_SETTING_PATIENTS_AS_INACTIVE } from '../../../settings/constants/appSettings';

const locale = globals.getAreas(['patients', 'error']);
export const eventHandlers = (state, setState, auth) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSettings(ENABLE_SETTING_PATIENTS_AS_INACTIVE));
  }, []);

  const faList = useSelector(store => store.global.auth.featureAccessList);
  const settingsObject = useSelector(store => store.entities.settings.appSettings);
  const enableIntegrationMode = checkFeatureAccess(faList, globals.applicationFeatureAccesses.enableIntegrationMode);

  const handleCreate = () => {
    dispatch(push('/Patients/Patient/Create'));
  };

  const importPatientEvent = (model, errorCallback) => {
    const callback = () => setState({ ...state, forceReload: !state.forceReload, showImportSidePanel: false });
    importPatient(auth, model, callback, errorCallback);
  };

  return {
    locale,
    auth,
    addButtonText: locale.getMsg('addPatient'),
    importButtonText: 'Import Patient',
    canAddPatients: checkFeatureAccess(faList, globals.applicationFeatureAccesses.canAddPatients),
    canEditPatients: checkFeatureAccess(faList, globals.applicationFeatureAccesses.canEditPatients),
    enableIntegrationMode,
    refreshTable: () => setState({ ...state, forceReload: !state.forceReload, mileageCapList: {} }),
    updateTableProps: (currentPage, pageSize) => setState({ ...state, currentPage, pageSize }),
    updateTableSort: (sortColumn, sortDirection) => setState({ ...state, sortColumn, sortDirection }),
    goBack: () => dispatch(goBack()),
    go: url => dispatch(push(url)),
    onFiltersChange: model =>
      setState({
        ...state,
        forename: model.forename,
        surname: model.surname,
        nhsNumber: model.nhsNumber.replace(/ /g, ''),
        dateOfBirth: model.dateOfBirth,
        postCode: model.postCode,
        status: model.status,
        currentPage: 1,
      }),
    handleSidePanel: !enableIntegrationMode ? handleCreate : null,
    handleImportEvent: enableIntegrationMode
      ? showPanel => setState({ ...state, showImportSidePanel: showPanel })
      : null,
    importPatientEvent: enableIntegrationMode ? importPatientEvent : null,
    isSettingPatientsAsInactiveEnabled: () => {
      const enableSettingPatientsAsInactiveSetting = _.get(settingsObject, ENABLE_SETTING_PATIENTS_AS_INACTIVE, false);
      return enableSettingPatientsAsInactiveSetting === 'true';
    },
  };
};
